import { useMemo, useState } from 'react';

import { PostHog } from '@atlas/base';
import { SiteConfigManager } from '@atlas/core';

const mockPostHog = {
  init: () => Promise.resolve(),
  concat: Function.prototype,
  send: Function.prototype,
  login: Function.prototype,
  logout: Function.prototype,
};

let postHog = mockPostHog;
let initialized = false;

const usePostHog = () => {
  const [instance, setInstance] = useState(postHog);

  if (!initialized) {
    initialized = true;
    if (SiteConfigManager.getConfig('config.config.general.postHog.enabled', false) === true) {
      postHog = new PostHog({
        apiKey: SiteConfigManager.getConfig('config.config.general.postHog.apiKey'),
        apiUrl: SiteConfigManager.getConfig('config.config.general.postHog.apiHost'),
      });
      setInstance(postHog);
    }
  }

  return useMemo(
    () => ({
      init: postHog.init.bind(postHog),
      concat: postHog.concat.bind(postHog),
      send: postHog.send.bind(postHog),
      login: postHog.login.bind(postHog),
      logout: postHog.logout.bind(postHog),
      initialized,
    }),
    [instance, initialized],
  );
};

export default usePostHog;